<template>
  <div>
    <VTextField
      v-model="data.name[selectedLang]"
      :label="`${$t('forms.labels.name')} (${$t(`langs.${selectedLang}`)})`"
      :rules="{ required: selectedLang === teamMainLang, min: 1, max: 200 }"
      outlined
      dataCy="nameVideoCategory"
      @input="updateData"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField';

export default {
    components: {
        VTextField,
    },
    props: {
        name: {
            type: Object,
            default: () => ({}),
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        data: {
            name: { },
        },
    }),
    computed: {
        ...mapGetters([
            'teamLangs',
            'teamMainLang',
            'selectedLang',
        ]),
    },
    created() {
        if (this.isEdition) {
            this.data = this.name;
        }
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.data);
        },
    },
};
</script>
